import React from "react"
import styled from "styled-components"

import Flex from "../components/Flex"
import SEO from "../components/seo"

const FormWrapper = styled.div`
    width: 100%;
`
const FormInfo = styled.div`
    margin-bottom: 40px;
    h2 {
        margin: 16px 32px;
        padding: 16px;
        font-size: 48px;
    }
    h3 {
        margin: 8px 32px;
        padding: 16px;
    }
    p {
        display: block;
        width: 85%;
        margin: 0 auto;
        text-align: justify;
    }
`

const ContactForm = styled.form`
    margin: 40px auto;
    padding: 16px;
    max-width: 768px;
    height: auto;
    -webkit-box-shadow: 0px 5px 37px -6px rgba(204,204,204,1);
    -moz-box-shadow: 0px 5px 37px -6px rgba(204,204,204,1);
    box-shadow: 0px 5px 37px -6px rgba(204,204,204,1);
`

const InputWrapper = styled.div`
    margin: 0 auto;
    width: 85%;
`
const Field = styled.div`
    margin-bottom: 34px;
`
const StyledLabel = styled.label`
    display: none;
    margin-bottom: 8px;
    color: var(--color-grey);
`
const StyledInput = styled.input`
    height: 32px;
    width: 100%;
    padding: 8px;
    border: none;
    border-bottom: 1px solid var(--color-green);
    font-size: 16px;
    &:focus {
        outline: none;
    }
`
const StyledTextArea = styled.textarea`
    width: 100%;
    height: 104px;
    padding: 8px;
    overflow: scroll;
    resize: none;
    border: none;
    border-left: 1px solid var(--color-green);
    &:focus {
        outline: none;
    }
`

const SubmitButton = styled.button`
    display: block;
    width: 120px;
    padding: 16px;
    background-color: transparent;
    border: 2px solid var(--color-green);
    border-radius: 25px;
    font-size: 14px;
    color: var(--color-green);
    cursor: pointer;
    transition: all ease 0.3s;
    -webkit-transition: all ease 0.3s;
    -moz-transition: all ease 0.3s;
    -o-transition: all ease 0.3s;
    &:hover {
        background-color: var(--color-green);
        color: var(--color-white);
    }
`
const FormActionWrapper = styled(Flex)`
    width: auto;
`

const Contact = () => {
    return (
        <>
            <SEO title="Contact us" />
            <FormWrapper>
                <ContactForm name="contact" method="POST" action="/danku" data-netlify="true" netlify-honeypot="bot-field" data-netlify-recaptcha="true">
                    <FormInfo>
                        <h2>Laat van je horen</h2>
                        <p>Is er een plaat die in onze rekken ontbreekt? Ben je op zoek naar iets bijzonders of wil je je favoriete album liever op cd? Bestel hem dan online, laat je e-mailadres achter en wij laten je weten zodra je hem kan komen ophalen bij George and the Bear!</p>
                        <h3>Hebben jullie net een nieuwe plaat opgenomen? </h3>
                        <p>Kom hem dan voorstellen bij George and the Bear, waar we je kunnen helpen bij de cd-release. Voor alle mogelijkheden omtrent de ondersteuning van onze lokale muzikanten kan men best eens langskomen in de winkel of via dit formulier</p>
                    </FormInfo>
                    <input name="form-name" value="contact" aria-label="form-name" readOnly hidden />
                    <input name="bot-field" aria-label="form-bot-field" readOnly hidden />
                    <InputWrapper>
                        <Field>
                            <StyledLabel htmlFor="first-name">voornaam</StyledLabel>
                            <StyledInput type="text" name="first-name" id="first-name" placeholder="voornaam" />
                        </Field>
                        <Field>
                            <StyledLabel htmlFor="last-name">Achternaam</StyledLabel>
                            <StyledInput type="text" name="last-name" id="last-name" placeholder="achternaam" />
                        </Field>
                        <Field>
                            <StyledLabel htmlFor="email">E-Mail</StyledLabel>
                            <StyledInput type="email" name="email" id="email" placeholder="email" required />
                        </Field>
                        <Field>
                            <StyledLabel htmlFor="message">Bericht</StyledLabel>
                            <StyledTextArea name="message" id="message" placeholder="Vul hier een boodschap in" required></StyledTextArea>
                        </Field>
                    </InputWrapper>
                    <FormActionWrapper justifyContent="center">
                        <div data-netlify-recaptcha="true"></div>
                        <SubmitButton type="submit">Verstuur</SubmitButton>
                    </FormActionWrapper>
                </ContactForm>
            </FormWrapper>
        </>
    )
}

export default Contact